import { Button, Calendar, Dialog, InputText, Tag, Toast } from 'primereact';
import React, { useContext, useEffect, useRef, useState } from 'react'


import Card from '../../../Base/Components/Card/Card';
import { useForm } from '../../../Base/Hooks/useForm';
import { toastShow } from '../../../Base/Services/ToastService';
import { cancelVisitaDetalle, getVisitaTipos, saveVisita, updateVisita } from '../../../API/Logistica/Visitas/VisitasRequests';
import Loader from '../../../Base/Components/Loader/Loader';
import { getDateTimeStringSQL } from '../../../Base/Services/Moment/Luxon';
import { useParams } from 'react-router-dom';
import { decodeToken } from 'react-jwt';
import { getPublicAreas } from '../../../API/Global/Areas/AreasRequests';
import AutoCompleteDropdown from '../../../Base/Components/Form/AutoCompleteDropdown';
import { getPublicAgentesFirma } from '../../../API/Global/Agentes/AgentesRequests';
import { colors } from '../../../Styles/Colors';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';

import { Checkbox } from 'primereact/checkbox';


const ProgramacionVisitasCrud = ({ showDialogEdit, onHide, key, visitaEdit, onEdit }) => {

    const { userAuth } = useContext(AuthContext);

    let { token } = useParams();
    let { user } = useParams();
    if (!token) {
        user = userAuth;
        token = localStorage.getItem('TokenPPF');
    } else {
        user = decodeToken(token);
    }


    const [newDetalle, setNewDetalle] = useState({ IdVisitaEnc: -100, NombreVisita: '', Asistencia: null, IdVisitaDetalle: -1, IdStatus: 3648, StatusName: 'Solicitado' });
    const [loading, setLoading] = useState(false);
    const [areas, setAreas] = useState([]);
    const [agentes, setAgentes] = useState([]);
    const [enable, setEnable] = useState(false);
    const [tiposVisita, setTiposVisita] = useState([]);
    const toast = useRef(null);

    const initialForm = {
        IdVisitaEnc: -100,
        FechaProgramada: new Date(),
        Motivo: '',
        Detalle: [],
        IdUsuarioSolicita: user.idUser,
        IdUsuarioCreo: user.idUser,
        UsuarioCreo: user.Usuario,
        IdStatus: 3648,
        StatusName: 'Solicitado',
    }

    const { values, handleInputChange, setValues, resetForm, handleChange } = useForm(initialForm);

    const getInfo = async () => {
        setLoading(true)
        const a = await getPublicAreas(token);
        const f = await getPublicAgentesFirma(token);
        const t = await getVisitaTipos(token);
        setTiposVisita(t);
        setAreas(a);
        setAgentes(f);
        setLoading(false)
    }

    const verificarInfo = () => {
        let error = false;
        if (values?.Detalle.length === 0) {
            toastShow(toast, 'warn', 'Advertencia', 'Ingrese al menos un visitante');
            error = true;
        }
        if (!values?.Motivo || values?.Motivo === '') {
            toastShow(toast, 'warn', 'Advertencia', 'Ingrese el motivo de la visita');
            error = true;
        }
        if (!values?.FechaProgramada) {
            toastShow(toast, 'warn', 'Advertencia', 'Ingrese la fecha de la visita');
            error = true;
        }
        if (!values?.Area) {
            toastShow(toast, 'warn', 'Advertencia', 'Ingrese el área');
            error = true;
        }
        if (!values?.Solicita) {
            toastShow(toast, 'warn', 'Advertencia', 'Ingrese el solicitante');
            error = true;
        }
        if (values?.VisitaAbierta && !values?.FechaVencimiento) {
            toastShow(toast, 'warn', 'Advertencia', 'Ingrese la fecha de vencimiento');
            error = true;
        }
        if (values?.VisitaAbierta) {
            if(values?.FechaVencimiento < values?.FechaProgramada){
                toastShow(toast, 'warn', 'Advertencia', 'La fecha de vencimiento debe ser mayor a la fecha de visita');
                error = true;
            }
        }
        return error;
    }

    const reset = () => {
        resetForm();
        setNewDetalle({ IdVisitaEnc: -100, NombreVisita: '', Asistencia: null, IdVisitaDetalle: -1, IdStatus: 3648, StatusName: 'Solicitado' });
        setValues(initialForm);
    }

    const guardar = async () => {
        setLoading(true);
        if (verificarInfo()) {
            setLoading(false);
            return
        };
        // NUEVA VISTA GUARDAR
        if (values.IdVisitaEnc < 0) {
            const res = await saveVisita({
                ...values,
                FechaProgramada: getDateTimeStringSQL(values.FechaProgramada),
                FechaVencimiento: values.VisitaAbierta ? getDateTimeStringSQL(values.FechaVencimiento) : null,
                IdAreaSolicita: values.Area.IdArea,
                IdUsuarioSolicita: values.Solicita.idUser,
                IdTipoVisita: values.TipoVisita.IdTipoVisita,
                Area: undefined,
                Solicita: undefined,
            }, token);
            if (res.length > 0) {
                if (res[0].ESTADO > 0) {
                    toastShow(toast, 'success', 'Exito', res[0].MENSAJE);
                    onEdit(res[0].NoVisita);
                    onHide();
                } else {
                    toastShow(toast, 'warn', 'Advertencia', res[0].MENSAJE);
                }
            }
        } else {
            // ACTURALIZAR VISITA
            const res = await updateVisita(values, token);
            if (res.length > 0) {
                if (res[0].ESTADO > 0) {
                    toastShow(toast, 'success', 'Exito', res[0].MENSAJE);
                    onEdit(visitaEdit.NoVisita);
                    onHide();
                } else {
                    toastShow(toast, 'warn', 'Advertencia', res[0].MENSAJE);
                }
            }
        }
        setLoading(false);
    }

    const cancelarDetalleVisita = async (item) => {
        const d = {
            ...values,
            Detalle: [item]
        }
        if(item.IdVisitaDetalle > 0){
            const res = await cancelVisitaDetalle(d, token);
            // onEdit(visitaEdit.IdVisitaEnc)
            if (res.length > 0) {
                if (res[0].ESTADO > 0) {
                    toastShow(toast, 'success', 'Exito', res[0].MENSAJE);
                    onEdit(visitaEdit.NoVisita);
                } else {
                    toastShow(toast, 'warn', 'Advertencia', res[0].MENSAJE);
                }
            }
        }else{
            const updatedDetalle = values.Detalle.filter(det => det !== item);
            setValues({
                ...values,
                Detalle: updatedDetalle
            });
        }
    }

    const addVisitaDetalle = () => {

        if (!newDetalle || newDetalle === '') {
            toastShow(toast, 'warn', 'Advertencia', 'Ingrese el nombre del visitante');
            return;
        }
        if(newDetalle?.NombreVisita === ''){
            toastShow(toast, 'warn', 'Advertencia', 'Ingrese el nombre del visitante');
            return;
        }
        setValues({
            ...values,
            Detalle: [...values.Detalle, newDetalle]
        });
        setNewDetalle({ IdVisitaEnc: values.IdVisitaEnc, NombreVisita: '', Asistencia: null, IdVisitaDetalle: - values.Detalle.length, IdStatus: 3648, StatusName: 'Solicitado' });
    }



    const setTag = (item) => {
        // --Estados disponibles
        // --3648	Solicitado
        // --3649	Aprobado
        // --3650	visita en planta
        // --3651	visita finalizada
        // --3652	cancelada

        switch (item.IdEstado) {
            case 3648:
                return <Tag style={{ backgroundColor: colors.primary, color: '#FFF', fontWeight: '600', fontSize: 10 }}><span>{item.StatusName}</span></Tag>
                break;
            case 3649:
                return <Tag style={{ backgroundColor: colors.green, color: '#FFF', fontWeight: '600', fontSize: 10 }}><span>{item.StatusName}</span></Tag>
                break;
            case 3650:
                return <Tag style={{ backgroundColor: colors.borderColorCotton, color: '#FFF', fontWeight: '600', fontSize: 10 }}><span>{item.StatusName}</span></Tag>
                break;
            case 3651:
                return <Tag style={{ backgroundColor: colors.borderColorSintetico, color: '#FFF', fontWeight: '600', fontSize: 10 }}><span>{item.StatusName}</span></Tag>
                break;
            case 3652:
                return <Tag style={{ backgroundColor: colors.white, color: '#FFF', fontWeight: '600', fontSize: 10 }}><span>{item.StatusName}</span></Tag>
                break;
            default:
                return <Tag style={{ backgroundColor: colors.primary, color: '#FFF', fontWeight: '600', fontSize: 10 }}><span>{item.StatusName}</span></Tag>
                break;
        }

    }

    useEffect(() => {
        if (showDialogEdit) {
            getInfo();
        }
    }, [showDialogEdit])

    useEffect(() => {
        reset();
        if (visitaEdit) {
            setValues({
                ...visitaEdit,
                Area: areas.find(x => x.IdArea === visitaEdit.IdAreaSolicita),
                Solicita: agentes.find(x => x.idUser === visitaEdit.IdUsuarioSolicita),
            });
            setEnable(visitaEdit?.IdEstado === 3648);
            setLoading(false);
        } else {
            setEnable(true);
            setValues(initialForm);
        }
    }, [visitaEdit, areas, agentes])


    return (
        <div key={key} id='ListVisitas'>
            <Dialog
                visible={showDialogEdit}
                header={'Visita ' + (visitaEdit?.NoVisita || '')}
                onHide={onHide}
            >
                <div style={{ width: '80vw' }}>
                    <Toast ref={toast} position='bottom-right' />
                    <Loader loading={loading} querySelector='#ListVisitas'/>
                    <Card
                        contenido={
                            <div>
                                <div className='d-flex mt-4' style={{ gap: 10, alignItems: 'center' }}>
                                    <div className="field col-1">
                                        <span className="p-float-label col-12">
                                            <InputText
                                                className='col-12'
                                                value={values?.UsuarioCreo}
                                                name='UsuarioCreo'
                                                onChange={handleChange}
                                                disabled
                                            />
                                            <label htmlFor="float-input">Creado por</label>
                                        </span>
                                    </div>
                                    <div className="field col-2">
                                        <span className="p-float-label">
                                            <Calendar
                                                value={values?.FechaProgramada}
                                                name='FechaProgramada'
                                                onChange={handleInputChange}
                                                dateFormat={'dd/mm/yy'}
                                                selectionMode={'single'}
                                                view={'date'}
                                                showButtonBar
                                                showIcon
                                                monthNavigator
                                                yearNavigator
                                                yearRange='2010:2030'
                                                disabled={!enable}
                                                minDate={new Date()} 
                                            />
                                            <label htmlFor="float-input">Fecha Visita</label>
                                        </span>
                                    </div>

                                    <div className="field col-2">
                                        <AutoCompleteDropdown
                                            value={values?.TipoVisita}
                                            name='TipoVisita'
                                            items={tiposVisita}
                                            field='ClaseTipo'
                                            label={'Tipo Visita'}
                                            // onChange={handleInputChange}
                                            handleInputChange={handleInputChange}
                                            habilitar={!enable}
                                        />
                                    </div>


                                    <div className="field col-2">
                                        <AutoCompleteDropdown
                                            value={values?.Area}
                                            name='Area'
                                            items={areas}
                                            field='Area'
                                            label={'Área'}
                                            // onChange={handleInputChange}
                                            handleInputChange={handleInputChange}
                                            habilitar={!enable}

                                        />
                                    </div>
                                    <div className="field col-2">
                                        <AutoCompleteDropdown
                                            value={values?.Solicita}
                                            name='Solicita'
                                            items={agentes}
                                            field='AgentName'
                                            label={'Solicita'}
                                            // onChange={handleInputChange}
                                            handleInputChange={handleInputChange}
                                            habilitar={!enable}
                                        />
                                    </div>

                                </div>
                                <div className='my-3 col-12 d-flex gap' style={{ minHeight: 43 }}>
                                    <div className="field col-3 " style={{ flex: 1 }}>
                                        <span className="p-float-label col-12">
                                            <InputText
                                                className='col-12'
                                                value={values?.Motivo}
                                                name='Motivo'
                                                onChange={handleInputChange}
                                                disabled={!enable}
                                            />
                                            <label htmlFor="float-input">Motivo</label>
                                        </span>
                                    </div>
                                    <div className=' d-flex col-5' style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <div className="field ">
                                            <div className="" onClick={e => {
                                                setValues({
                                                    ...values,
                                                    VisitaAbierta: !values?.VisitaAbierta,
                                                    VisitaPermanente: false,
                                                })

                                            }}>
                                                <Checkbox id='VisitaAbierta' value={'VisitaAbierta'} name='VisitaAbierta' checked={values?.VisitaAbierta} disabled={!enable} />
                                                <label className='mx-2' htmlFor="VisitaAbierta">Visita abierta</label>
                                            </div>
                                        </div>
                                        <div className="field mx-2">
                                            <span className="col-12" onClick={e => {
                                                setValues({
                                                    ...values,
                                                    VisitaAbierta: false,
                                                    VisitaPermanente: !values?.VisitaPermanente,
                                                })

                                            }}>
                                                <Checkbox id='VisitaAbierta' value={'VisitaPermanente'} name='VisitaPermanente' checked={values?.VisitaPermanente} disabled={!enable} />
                                                <label className='mx-2' htmlFor="VisitaPermanente">Visita Permanente</label>
                                            </span>
                                        </div>
                                        <div className="field">
                                            {values.VisitaAbierta && <span className="p-float-label">
                                                <Calendar
                                                    value={values?.FechaVencimiento}
                                                    name='FechaVencimiento'
                                                    onChange={handleInputChange}
                                                    dateFormat={'dd/mm/yy'}
                                                    selectionMode={'single'}
                                                    view={'date'}
                                                    showButtonBar
                                                    showIcon
                                                    monthNavigator
                                                    yearNavigator
                                                    yearRange='2010:2030'
                                                    minDate={new Date()} 

                                                />
                                                <label htmlFor="float-input">Fecha Vencimiento</label>
                                            </span>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        }
                    />
                    <Card
                        titulo={'Visitantes'}
                        contenido={<div >
                            <div>
                                <div className='d-flex gap mt-4' >
                                    <InputText
                                        // className='col-11'
                                        value={newDetalle.NombreVisita}
                                        name='newDetalle'
                                        onChange={e => setNewDetalle({ ...newDetalle, NombreVisita: e.target.value })}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter') {
                                                addVisitaDetalle();
                                            }
                                        }}
                                        style={{ flex: 1 }}
                                    />
                                    <Button
                                        icon={'pi pi-plus'}
                                        className='p-button-success'
                                        onClick={addVisitaDetalle}
                                    />
                                </div>
                                <div className='mt-3' style={{ minHeight: '30vh', maxHeight: '40vh', overflowY: 'scroll' }}>
                                    {/* listado de visitantes */}
                                    {values?.Detalle.map((item, index) => <div className='d-flex gap hover ' style={{ alignItems: 'center' }} key={index}>
                                        <li style={{ flex: 1 }}>{item?.NombreVisita}</li>
                                        {setTag(item)}
                                        {/* <Checkbox
                                            checked={item?.Asistencia}
                                            tooltip='Asistencia'
                                        /> */}
                                        {/* EDITAR */}

                                        {/* // --3650	visita en planta
                                        // --3651	visita finalizada
                                        // --3652	cancelada */}
                                        <Button
                                            icon={'pi pi-pencil'}
                                            className='p-button-info p-button-text'
                                            tooltip='Editar'
                                            disabled={item.IdEstado == 3650 || item.IdEstado == 3651 || item.IdEstado == 3652}
                                            onClick={() => {
                                                const newDetalle = values?.Detalle.filter((x, i) => i !== index);
                                                setValues({
                                                    ...values,
                                                    Detalle: newDetalle
                                                });
                                                setNewDetalle(item);
                                            }}
                                        />
                                        <Button
                                            icon={'pi pi-trash'}
                                            className='p-button-danger p-button-text'
                                            tooltip='Eliminar'
                                            disabled={item.IdEstado == 3650 || item.IdEstado == 3651 || item.IdEstado == 3652}
                                            onClick={() => {
                                                cancelarDetalleVisita(item);
                                            }}
                                        />
                                    </div>)}
                                </div>

                            </div>
                        </div>}
                    />

                    <div className='d-flex mt-4 gap' style={{ justifyContent: 'flex-end' }}>
                        <Button icon={'pi pi-times'} label='Cancelar' className='p-button-secondary' onClick={onHide} />
                        <Button icon={'pi pi-save'} label='Guardar' className='p-button-success' onClick={guardar} />

                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default ProgramacionVisitasCrud